var exports = {
  "u": "SavedReplies__XjHxn2",
};

module.exports = exports;
